import { __awaiter } from "tslib";
import { CFG_EVENT } from "../context/ConfigurationEventEmitterContext";
/**
 * Emits configuration event to the event emitter
 *
 * @param event
 * @returns
 */
export function emitConfigurationEvent(event) {
    return (_dispatch_1, _getState_1, _a) => __awaiter(this, [_dispatch_1, _getState_1, _a], void 0, function* (_dispatch, _getState, { eventEmitter }) {
        // emit configuration event to internal emitter
        try {
            // TODO no wildcard support yet
            eventEmitter.emit(CFG_EVENT, event);
        }
        catch (err) {
            console.warn("eventEmitter.emit failed", err);
        }
    });
}
//# sourceMappingURL=emitConfigurationEvent.js.map